import styled from 'styled-components'
// import img from './images/logo.svg'
import {NavLink} from 'react-router-dom'
import devices from './../../../interface/devices'

import logo from './images/blackswan-w.svg';
import swan from './images/swan-w.svg';

export const Warning = styled.img`
  cursor: pointer;
  position: relative;
  top: 3px;
  width: 24px;
  height: 24px;
  background-color: #7F818D !important;
  background-size: 100px !important;
  -webkit-mask: url('/images/warning-2.svg') no-repeat center !important;
  mask: url('/images/warning-2.svg') no-repeat center !important;
  
  &:hover{
    opacity: 0.7;
  }
`

export const AvatarContainer = styled.div.attrs({className:'avatar-container'})`
  position: relative;
  top: 3px;
  cursor: pointer;
`
export const Burger = styled.img`
  cursor: pointer;
  margin-right: 24px;
`

export const FirstHeaderContainer = styled.div`
    background: #2B2D39;
    padding: 10px 0 10px 55px;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    
    
    @media ${devices.mobileL} { 
     // max-width: 500px;
    }
    @media ${devices.tablet} { 
      //max-width: 700px;
    }
    @media ${devices.laptop} { 
      //max-width: 710px;
    }
    @media (min-width: 1280px) { 
     // max-width: 1100px;
    }
    @media (min-width: 1550px) {
      //max-width: 1300px;
    }
    @media (min-width: 1900px) {
     // max-width: 1550px;
    }
`

export const MenuContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: 30px;
`

export const HeaderLogo = styled.div`
    display: flex;
    align-items: center;
`
export const HeaderShadow = styled.div`
    box-shadow: 0 5px 32px rgb(0 0 0 / 12%);
    position: relative;
    min-width: 980px;
    background-color: #2B2D39;
    
    @media (min-width: 1280px) { 
      min-width: 1100px;
    }
    @media (min-width: 1550px) { 
      min-width: 1300px;
    }
    @media (min-width: 1900px) { 
      min-width: 1550px;
    }
`

export const Swan = styled(NavLink)`
    background: no-repeat url(${swan}) center center;
    background-size: cover;
    width: 27px;
    height: 30px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: none;
    display: inline-block;
    margin-right: 10px;
`

export const Text = styled(NavLink)`
    background: no-repeat url(${logo}) center center;
    width: 136px;
    height: 20px;
    margin-left: 5px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: none;
    display: inline-block;
    background-size: cover;
    margin-top: 2px;
`

export const HeaderRightContainer = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
`

export const LogoutContainer = styled.div`
    display: flex;
    margin-left: auto;
`
